interface ProfileProps {
    src: string;
    alt?: string;
    size?: number;
    strokeWidth?: number;
    className?: string,
    mobileNav?: boolean;
}

export const Profile = ({ src, alt = "", size = 24, strokeWidth = 0, className = "relative w-7 h-7", mobileNav = false }: ProfileProps) => {
    const sizeClass = `${className}`;
    const isMobileNavProfile = mobileNav || className === "relative w-7 h-7";
    return (
        <div className={`relative flex items-center justify-center rounded-full overflow-hidden ${isMobileNavProfile ? "max-md:ring-2 max-md:ring-primary max-md:ring-offset-1 max-md:ring-offset-white" : ""} ${sizeClass}`}>
            {strokeWidth > 0 && (
                <svg
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute top-0 left-0 pointer-events-none"
                >
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={(size / 2)}
                        stroke="currentColor"
                        strokeWidth={strokeWidth}
                        fill="none"
                    />
                </svg>
            )}
            <img
                src={src}
                alt={alt}
                className="w-full h-full object-cover rounded-full p-[1px]"
                draggable={false}
            />
        </div>
    );
};
